import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import DropdownNotification from './dropdown/notification.jsx';
import DropdownLanguage from './dropdown/language.jsx';
import DropdownProfile from './dropdown/profile.jsx';
import SearchForm from './search/form.jsx';
import DropdownMegaMenu from './dropdown/mega.jsx';

function Header() {
	const appSettings = useSelector((state) => state.appSettings);
	const { appHeaderInverse, appHeaderMegaMenu, appHeaderLanguageBar, appSidebarTwo } = appSettings;

	return (
		<div id="header" className={`app-header ${appHeaderInverse ? 'header-inverse' : ''}`} data-bs-theme={appHeaderInverse ? 'dark' : ''}>
			<div className="navbar-header">
				<Link to="/" className="navbar-brand">
					<img width="auto" alt="Logo" height="90px" src="/assets/img/logo.png" />
					&nbsp; <b>Super Admin</b>
				</Link>
			</div>

			{appHeaderMegaMenu && (
				<DropdownMegaMenu />
			)}

			<div className="navbar-nav">
				<SearchForm />
				<DropdownNotification />

				{appHeaderLanguageBar && (
					<DropdownLanguage />
				)}

				<DropdownProfile />

				{appSidebarTwo && (
					<div className="navbar-divider d-none d-md-block"></div>
				)}

				{appSidebarTwo && (
					<div className="navbar-item d-none d-md-block">
						<Link to="/" className="navbar-link icon">
							<i className="fa fa-th"></i>
						</Link>
					</div>
				)}
			</div>
		</div>
	);
}

export default Header;